import React, { createContext, useContext, useState, useRef, useEffect } from "react";
import axios from "axios";

const AudioContext = createContext();

export const useAudio = () => useContext(AudioContext);

export const AudioProvider = ({ children }) => {
  const [tracks, setTracks] = useState([]);
  const [isPlayingIndex, setIsPlayingIndex] = useState(null);
  const audioRef = useRef(new Audio());

  const userId = parseInt(localStorage.getItem("userid") || "1");

  useEffect(() => {
    axios
      .get("https://music-endpoint.onrender.com/songs/getallsongs")
      .then((response) => {
        const songs = response.data.data || [];
        const formattedTracks = songs.map((song) => ({
          title: song.songName,
          songId: song.songId,
          liked: false,
          imageUrl: `https://music-endpoint.onrender.com/songs/details/${encodeURIComponent(song.songName)}`,
        }));
        setTracks(formattedTracks);
      })
      .catch((error) => {
        console.error("Error fetching tracks:", error);
      });
  }, []);

  const playTrack = async (index) => {
    if (index < 0 || index >= tracks.length) return;

    const track = tracks[index];
    const audioURL = `https://music-endpoint.onrender.com/songs/play/${encodeURIComponent(track.title)}`;

    if (isPlayingIndex === index) {
      audioRef.current.pause();
      setIsPlayingIndex(null);
    } else {
      if (!audioRef.current.paused) {
        audioRef.current.pause();
      }
      audioRef.current.src = audioURL;
      try {
        await audioRef.current.play();
        setIsPlayingIndex(index);
        await axios.post("https://music-endpoint.onrender.com/api/history/save", {
          userId,
          songId: track.songId,
        });
      } catch (error) {
        console.error("Error playing audio:", error);
      }
    }
  };

  const pauseTrack = () => {
    audioRef.current.pause();
    setIsPlayingIndex(null);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleEnded = () => setIsPlayingIndex(null);
    const audioEl = audioRef.current;

    if (audioEl) {
      audioEl.addEventListener("ended", handleEnded);
    }

    return () => {
      if (audioEl) {
        audioEl.removeEventListener("ended", handleEnded);
      }
    };
  }, []);


  const toggleFavorite = async (index) => {
    if (index < 0 || index >= tracks.length) return;
    const track = tracks[index];

    try {
      if (!track.liked) {
        await axios.post("https://music-endpoint.onrender.com/favorites/save/songs", {
          userid: userId,
          songid: track.songId,
        });
      } else {
        await axios.delete(
          `https://music-endpoint.onrender.com/favorites/delete/songs/${userId}/${track.songId}`
        );
      }
      setTracks((prev) =>
        prev.map((t, i) => (i === index ? { ...t, liked: !t.liked } : t))
      );
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  return (
    <AudioContext.Provider
      value={{
        tracks,
        isPlayingIndex,
        playTrack,
        pauseTrack,
        toggleFavorite,
        audioRef,
      }}
    >
      {children}
    </AudioContext.Provider>
  );
};
